import React from 'react';
import { usePermissions } from '@/contexts/PermissionsContext';

/**
 * Section qui s'affiche uniquement si l'utilisateur a la permission requise
 * 
 * Usage:
 * <ProtectedSection resource="finance" action="export">
 *   <Button onClick={handleExport}>Exporter les données</Button>
 * </ProtectedSection>
 */
export const ProtectedSection = ({ 
  resource, 
  action, 
  children, 
  fallback = null 
}) => {
  const { hasPermission } = usePermissions();
  
  if (!hasPermission(resource, action)) {
    return fallback;
  }
  
  return <>{children}</>;
};

/**
 * Section qui s'affiche uniquement si l'utilisateur a AU MOINS UNE des permissions requises
 * 
 * Usage:
 * <ProtectedSectionAny resource="operations" actions={["create", "update"]}>
 *   <ActionPanel />
 * </ProtectedSectionAny>
 */
export const ProtectedSectionAny = ({ 
  resource, 
  actions, 
  children, 
  fallback = null 
}) => {
  const { hasAnyPermission } = usePermissions();
  
  if (!hasAnyPermission(resource, actions)) {
    return fallback;
  }
  
  return <>{children}</>;
};
